// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CalendarCheckIconSignature {
  Element: SVGSVGElement;
}

export const CalendarCheckIcon: TOC<CalendarCheckIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21 4H18V2H16V8H18V6H21V21H3V6H5V4H3C1.896 4 1 4.896 1 6V21C1 22.104 1.896 23 3 23H21C22.104 23 23 22.104 23 21V6C23 4.896 22.104 4 21 4ZM15 4H8V2H6V8H8V6H15V4ZM7.293 14.707L11 18.414L16.707 12.707L15.293 11.293L11 15.586L8.707 13.293L7.293 14.707Z"/>
</svg>
</template>;